<template>
  <div class="row mt-2">
    <div class="col-md-3" data-v-step="1">
      <score-card-component title="Media Online" :value_copy="data ? data.formed.toString() : ''">
        <loader-component v-if="isloading" />
        <span v-else style="color: #000000">
          <i class="bi bi-newspaper" /> {{ data.formed | number_format }}
        </span>
      </score-card-component>
    </div>
    <div class="col-md-3" data-v-step="2">
      <score-card-component title="Media Sosial" :value_copy="data ? data.medsos.toString() : ''">
        <loader-component v-if="isloading" />
        <span v-else style="color: #28a745">
          <i class="bi bi-globe-americas" /> {{ data.medsos | number_format }}
        </span>
      </score-card-component>
    </div>
    <div class="col-md-3" data-v-step="3">
      <score-card-component title="Jumlah Keterlibatan" :value_copy="data ? data.engagement.toString() : ''">
        <loader-component v-if="isloading" />
        <span v-else style="color: #17a2b8">
          <i class="bi bi-share-fill" /> {{ data.engagement | number_format }}
        </span>
      </score-card-component>
    </div>
    <div class="col-md-3" data-v-step="4">
      <score-card-component title="Jumlah Jangkauan" :value_copy="data ? data.reach.toString() : ''">
        <loader-component v-if="isloading" />
        <span v-else style="color: #fd7e14">
          <i class="bi bi-megaphone" /> {{ data.reach | number_format }}
        </span>
      </score-card-component>
    </div>
  </div>
</template>

<script>
import score_card from "@/views/components/score_card.vue";
import loader_component from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "score_card",
  components: {
    "loader-component": loader_component,
    "score-card-component": score_card,
  },
  props: {
    data: Object,
    isloading: Boolean,
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);

      // if (Math.abs(number) > 999999) {
      //   return Math.sign(number) * ((Math.abs(number) / 1000000).toFixed(1)) + 'jt';
      // } else if (Math.abs(number) > 999) {
      //   return Math.sign(number) * ((Math.abs(number) / 1000).toFixed(1)) + 'rb';
      // } else {
      //   return Math.sign(number) * Math.abs(number);
      // }
    },
  },
};
</script>